import { distinctProperty, sum } from "@common/lang/lang";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MathematicalHelperService } from '@common/services/mathematical-helper-service';
import * as fromArrearsListingWidget from "@feature/_app_modules/arrears-listing-widget/reducers/arrears-listing-widget.reducers";
import { ITable } from "@common/models/table";
import * as lodash from "lodash";

export const selectArrearsListingWidgetState = createFeatureSelector<fromArrearsListingWidget.State>('ArrearsListingWidget');

const {
  selectEntities
} = fromArrearsListingWidget.adapter.getSelectors(selectArrearsListingWidgetState);

export const selectEntityByWidgetId = (widgetId: number) =>
  createSelector(
    selectEntities,
    (entities) => entities[widgetId]);

export const getWidgetLoading = (widgetId: number) =>
  createSelector(selectEntityByWidgetId(widgetId), (entity) => entity ? entity.loading : false);


const unfilteredData = (widgetId: number) =>
  createSelector(selectEntityByWidgetId(widgetId), (entity) => {
    if (entity.loading) return null;
    return entity.table;
  });

export const tableFilteredByCurrency = (widgetId: number, currencyCode: string) =>
  createSelector(unfilteredData(widgetId),
    (table: ITable) => {
      const filteredTable = lodash.cloneDeep(table);
      if (filteredTable && filteredTable.Rows) {
        filteredTable.Rows = filteredTable.Rows.filter(x => x['SystemCurrencyCode'] == currencyCode);
      }
      return filteredTable;
    });

export const outstandingAmountTotal = (widgetId: number, currencyCode: string) =>
  createSelector(tableFilteredByCurrency(widgetId, currencyCode),
    (table: ITable) => {
      if (table && table.Rows) {
        const mathematicalHelperService: MathematicalHelperService = new MathematicalHelperService;
        return mathematicalHelperService.precisionRound(sum(table.Rows, 'SystemOutstanding'), 2);
      } else return 0;
    });

export const tableData = (widgetId: number, widgetConfigId: number) =>
  unfilteredData(widgetId);


export const distinctCurrenciesFromTableData = (widgetId: number) =>
  createSelector(
    unfilteredData(widgetId),
    (table) => {
      if (!table) return [];
      return <string[]>distinctProperty(table.Rows, 'SystemCurrencyCode');
    },
  );

export const getCurrency = (widgetId: number) =>
  createSelector(
    distinctCurrenciesFromTableData(widgetId),
    (currencies) => { return currencies[0] });

export const asAtDate = (widgetId: number) =>
  createSelector(
    unfilteredData(widgetId),
    (table) => {
      if (!table) return new Date();
      var dates = <Date[]>distinctProperty(table.Rows, 'SystemDateCreated');
      return dates[0];
    }
  );
